import Handlebars from "@cirrus/legacy/vendor-bower/handlebars/handlebars"

Handlebars.registerHelper("if_any", function () {
  var args = [].slice.apply(arguments)
  var opts = args.pop()

  var fn = opts.inverse
  for (var i = 0; i < args.length; ++i) {
    if (args[i]) {
      fn = opts.fn
      break
    }
  }
  return fn(this)
})

Handlebars.registerHelper("if_equal", function (item, v2, options) {
  if (item === v2) {
    return options.fn(this)
  }
  return options.inverse(this)
})
